import { render, staticRenderFns } from "./Notificationbar.vue?vue&type=template&id=a0d278b0&scoped=true"
import script from "./Notificationbar.vue?vue&type=script&lang=js"
export * from "./Notificationbar.vue?vue&type=script&lang=js"
import style0 from "./Notificationbar.vue?vue&type=style&index=0&id=a0d278b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d278b0",
  null
  
)

export default component.exports